module.exports = __webpack_public_path__ + "img/Feature.a8cd0e9d.jpg";